import React from 'react'

const FormatorHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4473_29158)" />
    <path
      d="M43.3079 26.3833C43.1786 29.7448 41.8211 32.3953 38.912 34.1407C35.2272 36.3387 30.6374 35.3043 28.0516 31.7488C25.2072 27.8055 25.9829 22.1167 29.797 19.2076C34.3222 15.7814 40.7221 17.7208 42.7261 23.151C43.114 24.1207 43.3079 25.2197 43.3079 26.3833Z"
      fill="white"
    />
    <path
      d="M51.7118 45.6476C51.13 43.1264 49.7078 41.1871 47.7038 39.6356C45.4412 37.8255 42.8554 36.7265 40.1402 35.9508C39.5584 35.7568 39.1059 35.8215 38.6534 36.274C37.4898 37.3083 36.1969 38.2134 34.9686 39.1831C34.904 39.1184 34.8393 39.0538 34.7747 39.0538C33.4818 38.0194 32.2535 37.0498 30.9606 36.0154C30.8313 35.8861 30.5727 35.8215 30.4434 35.8861C27.7283 36.5326 25.1425 37.6316 22.8799 39.2477C22.1042 39.8295 21.3284 40.5406 20.5527 41.1871C20.1002 41.5749 20.1002 41.7042 19.9062 41.8982C21.781 41.4456 24.4961 42.286 25.3365 44.4193C25.7243 45.5183 25.7243 46.6819 25.2072 47.7809C24.5607 49.0738 23.4617 49.9142 21.9749 50.2374C24.4314 51.2717 26.8879 51.8535 29.4738 52.1768V41.7689C30.6374 41.8982 31.6717 42.0274 32.7707 42.1567C34.6454 42.48 36.5201 43.0618 38.2009 44.0315C38.3948 44.1607 38.5241 44.29 38.5241 44.5486C38.5241 47.0698 38.5241 49.591 38.5888 52.0475C38.5888 52.1768 38.5888 52.3707 38.5888 52.5H39.6877C39.6877 52.3707 39.6877 52.2414 39.6877 52.1768C39.6877 50.0435 39.6231 47.9102 39.6231 45.7122C39.6231 45.1951 39.4938 44.5486 39.7524 44.1607C40.011 43.7729 40.6574 43.5789 41.1746 43.3204C42.9846 42.48 44.924 42.0921 46.8634 41.8335C47.4452 41.7689 48.027 41.7689 48.6734 41.7042V44.8072C50.1603 45.1304 51.1946 46.0355 51.9057 47.4577C51.9703 47.2637 52.035 47.1991 52.035 47.0698C51.7764 46.6819 51.7764 46.1647 51.7118 45.6476Z"
      fill="white"
    />
    <path
      d="M51.0008 49.2677C50.9362 51.0132 49.4493 52.4354 47.7039 52.4354C45.8939 52.3707 44.4717 50.8839 44.5363 49.0738C44.6009 47.3284 46.0878 45.9062 47.8332 45.9062C49.5786 45.9062 51.0008 47.4577 51.0008 49.2677Z"
      fill="white"
    />
    <path
      d="M21.0699 42.6739C22.9447 42.6739 24.4315 44.0961 24.4315 45.9062C24.4315 47.7162 22.9447 49.1384 21.1346 49.1384C19.3245 49.1384 17.9023 47.587 17.967 45.7769C18.0316 43.9668 19.3892 42.7385 21.0699 42.6739Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4473_29158"
        x1="35"
        y1="11"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
    </defs>
  </svg>
)

export default FormatorHome
